import { Navigate, Outlet, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
//
import Login from "./pages/Login";
import Register from "./pages/Register";
import DashboardApp from "./pages/DashboardApp";
import DashboardSwitch from "./pages/DashboardSwitch";
import AdminSettings from "./pages/AdminSettings";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import Users from "./pages/User";
import NotFound from "./pages/Page404";
import CheckTransactionStatus from "./pages/CheckTransactionStatus";
import ActiveTransaction from "./pages/ActiveTransaction";
import ChargerList from "./components/charger/ChargerList";
import { Charger } from "./components/charger/Charger";
import { TeamList } from "./components/Team/TeamList";
import UserList from "./components/user/UserList";
import User from "./components/user/User";
import { MainLayout } from "./layouts/MainLayout";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import { TransactionsList } from "./components/Transactions/TransactionsList/TransactionsList";
import { TransactionView } from "./components/Transactions/TransactionView";
import { RefundDetails } from "./components/RefundDetails";
import { TagList } from "./components/AuthCode/TagList";
import { Tag } from "./components/AuthCode/Tag";
import { PriceGroupList } from "./components/PriceGroup/PriceGroupList";
import PayoutList from "./components/payout/PayoutList";
import { PriceGroup } from "./components/PriceGroup/PriceGroup";
import { Team } from "./components/Team/Team";
import { CustomerList, Customer } from "./components/customer";
// import Course from "./components/course/course/Course";
// import CourseContent from "./components/course/course/CourseContent";
// import AddContent from "./components/course/course/AddContent";

// Reset Password
import { ResetPassword } from "./components/authentication/ResetPassword";
import ChangePassword from "./components/ChangePassword";
// My Profile
import Profile from "./pages/Profile";
import { Company } from "./components/company/Company";
import { RoleList } from "./components/roles/RoleList";
import { Role } from "./components/roles/Role";
import { CompanyList } from "./components/company/CompanyList";
import ServiceRequestView from "./components/ServiceRequest/ServiceRequestView";
import ServiceRequestFormView from "./components/ServiceRequest/SeviceRequestForm/ServiceRequestFormView";
import ChargingProfileView from "./components/charger/ChargingProfile/ChargingProfileView";
import ChargingProfileFormView from "./components/charger/ChargingProfile/ChargingProfileForms/ChargingProfileFormView";

//refund
import Refund from "./components/Refund";
import CMCustomerList from "./components/cmCustomer/CMCustomerList";
import ReportTabList from "./components/reportTab/ReportTabList";
import ChargingSite from "./components/chargingSite/ChargingSite";
import CMCustomerWalletForm from "./components/cmCustomer/CMCustomerWalletForm";
import WalletHistoryList from "./components/cmCustomer/WalletHistory";
import SendMessages from "./components/sendMessages/SendMessages";
import { VehicleList } from "./components/vehicle/VehicleList";
import { Vehicle } from "./components/vehicle/Vehicle";
import FAQ from "./pages/FAQ";
import { PaymentGatewayList } from "./components/paymentGateway/PaymentGatewayList";
import { AuditLogs } from "./components/auditLog/AuditLogs";
import WhatsAppAdmin from "./components/whatsapp/WhatsAppAdmin";
import { PaymentGateway } from "./components/paymentGateway/PaymentGateway";
import ApiKeyList from "./components/ApiKeys/ApiKeyList";
import LegalDocViewer from "./pages/legal/LegalDocViewer";

export default function Router({ isLoggedIn }) {
  return useRoutes([
    {
      path: "/",
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: "", element: <Navigate to="/dashboard" /> },
        {
          path: "dashboard",
          element: <Outlet />,
          children: [
            // { path: "", element: <DashboardApp /> },
            // Per-company: V2 shows when the company has it enabled from
            // Company → Settings (super admin), or via the ?dashboard=v2 preview.
            { path: "", element: <DashboardSwitch /> },
            { path: "user", element: <Users /> },
            { path: "products", element: <Products /> },
            { path: "blog", element: <Blog /> },
          ],
        },
        {
          path: "charger",
          element: <Outlet />,
          children: [
            { path: "", element: <ChargerList /> },
            { path: "new", element: <Charger /> },
            { path: ":id", element: <Charger /> },
          ],
        },
        {
          path: "chargingprofile",
          element: <Outlet />,
          children: [
            { path: "", element: <ChargingProfileView /> },
            { path: "new", element: <ChargingProfileFormView /> },
            {
              path: ":chargingProfileId",
              element: <ChargingProfileFormView />,
            },
          ],
        },
        {
          path: "team",
          element: <Outlet />,
          children: [
            { path: "", element: <TeamList /> },
            { path: "new", element: <Team /> },
            { path: ":id", element: <Team /> },
          ],
        },
        {
          path: "users",
          element: <Outlet />,
          children: [
            { path: "", element: <UserList /> },
            { path: "new", element: <User /> },
            { path: ":id", element: <User /> },
          ],
        },
        {
          path: "transactions",
          element: <Outlet />,
          children: [
            { path: "", element: <TransactionsList /> },
            { path: ":id", element: <TransactionView /> },
          ],
        },
        {
          path: "refund-details/:paymentId",
          element: <RefundDetails />,
        },
        {
          path: "tag",
          element: <Outlet />,
          children: [
            { path: "", element: <TagList /> },
            { path: "new", element: <Tag /> },
            { path: ":tagId", element: <Tag /> },
          ],
        },
        {
          path: "pricegroup",
          element: <Outlet />,
          children: [
            { path: "", element: <PriceGroupList /> },
            { path: "new", element: <PriceGroup /> },
            { path: ":priceGroupId", element: <PriceGroup /> },
          ],
        },
        {
          path: "payout",
          element: <PayoutList />,
        },
        {
          path: "profile",
          element: <Outlet />,
          children: [{ path: "", element: <Profile /> }],
        },
        {
          path: "customer",
          element: <Outlet />,
          children: [
            { path: "", element: <CustomerList /> },
            { path: "new", element: <Customer /> },
            { path: ":id", element: <Customer /> },
          ],
        },
        {
          path: "changepassword",
          element: <ChangePassword />,
        },
        {
          path: "company",
          element: <Outlet />,
          children: [
            { path: "", element: <CompanyList /> },
            { path: "new", element: <Company /> },
            { path: ":companyId", element: <Company /> },
          ],
        },
        {
          path: "servicerequest",
          element: <Outlet />,
          children: [
            { path: "", element: <ServiceRequestView /> },
            { path: "new", element: <ServiceRequestFormView /> },
            { path: "edit/:ticketId", element: <ServiceRequestFormView /> },
            // {path:"details/:ticketId",element:<ServiceRequestFormView/>}
          ],
        },
        {
          path: "roles",
          element: <Outlet />,
          children: [
            { path: "", element: <RoleList /> },
            { path: "new", element: <Role /> },
            { path: ":roleId", element: <Role /> },
          ],
        },
        {
          path: "refund",
          element: <Outlet />,
          children: [
            { path: "", element: <Refund /> },
            { path: ":id", element: <TransactionView /> },
          ],
        },
        {
          path: "cm-customer",
          element: <Outlet />,
          children: [
            { path: "", element: <CMCustomerList /> },
            { path: ":id", element: <CMCustomerWalletForm /> },
            { path: "wallet/:id", element: <WalletHistoryList /> },
          ],
        },
        {
          path: "send-messages",
          element: <Outlet />,
          children: [
            { path: "", element: <SendMessages /> },
          ],
        },
        {
          path: "vehicles",
          element: <Outlet />,
          children: [
            { path: "", element: <VehicleList /> },
            { path: "new", element: <Vehicle /> },
            { path: ":vehicleId", element: <Vehicle /> },
          ],
        },
        {
          path: "report",
          element: <Outlet />,
          children: [{ path: "", element: <ReportTabList /> }],
        },
        {
          path: "charging-site",
          element: <Outlet />,
          children: [
            { path: "", element: <ChargingSite /> },
            { path: "new", element: <ChargingSite /> },
            { path: ":id", element: <ChargingSite /> },
          ],
        },
        {
          path: "faq",
          element: <FAQ />,
        },
        {
          path: "payment-gateways",
          element: <Outlet />,
          children: [
            { path: "", element: <PaymentGatewayList /> },
            { path: "new", element: <PaymentGateway /> },
            { path: ":id", element: <PaymentGateway /> },
          ],
        },
        { path: "api-keys", element: <ApiKeyList /> },
        { path: "audit-logs", element: <AuditLogs /> },
        // Super-admin-only. The page itself redirects any non-root-super-admin.
        { path: "admin-settings", element: <AdminSettings /> },
        // Super-admin-only WhatsApp area. The page self-guards (GP super admin).
        { path: "whatsapp", element: <WhatsAppAdmin /> },
      ],
    },

    // {
    //   path: "/course",
    //   element: <DashboardLayout />,
    //   children: [
    //     { path: "", element: <CourseList /> },
    //     { path: ":id", element: <Course /> },
    //     { path: "content/:id", element: <CourseContent /> },
    //     { path: "content/add/:id", element: <AddContent /> },
    //   ],
    // },
    // {
    //   path: "/setup",
    //   element: <DashboardLayout />,
    //   children: [
    //     { element: <Navigate to="/setup/usertype" replace /> },
    //     { path: "usertype", element: <UserTypeList /> },
    //     { path: "usertype/:id", element: <UserType /> },
    //     { path: "category", element: <CategoryList /> },
    //     { path: "category/:id", element: <Category /> },
    //   ],
    // },
    // {
    //   path: "/account",
    //   element: <DashboardLayout />,
    //   children: [
    //     { element: <Navigate to="/account/basic" replace /> },
    //     { path: "basic", element: <BasicSetting /> },
    //     { path: "user", element: <UserSetting /> },
    //   ],
    // },
    {
      path: "/",
      element: !isLoggedIn ? <MainLayout /> : <Navigate to="/dashboard" />,
      children: [
        { path: "", element: <Navigate to="/login" replace /> },
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        { path: "reset", element: <ResetPassword /> },
        { path: "pagenotfound", element: <NotFound /> },
      ],
    },
    // Public route for transaction status check (no authentication required)
    {
      path: "/check-transaction-status",
      element: <LogoOnlyLayout />,
      children: [
        { path: "", element: <CheckTransactionStatus /> },
      ],
    },
    // Public route for active transaction lookup (no authentication required)
    {
      path: "/active-transaction",
      element: <LogoOnlyLayout />,
      children: [
        { path: "", element: <ActiveTransaction /> },
      ],
    },
    // Legal documents — reachable ONLY via direct link and ONLY by the root
    // super admin. Not linked in the sidebar; the viewer itself redirects any
    // non-root-super-admin (or logged-out) visitor to the not-found page.
    {
      path: "/legal/software-license-agreement",
      element: (
        <LegalDocViewer
          docKey="software-license-agreement"
          isLoggedIn={isLoggedIn}
        />
      ),
    },
    {
      path: "/legal/mnda",
      element: <LegalDocViewer docKey="mnda" isLoggedIn={isLoggedIn} />,
    },
    { path: "*", element: <Navigate to="/pagenotfound" replace /> },
  ]);
}
